import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../services/core/alert.service';
import { ProgressService } from '@shared';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { SUPPRESS_GLOBAL_ERROR_FEEDBACK } from './feedback-context';

export function errorInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const progressService = inject(ProgressService);
  const alertService = inject(AlertService);
  const authService = inject(AuthService);
  const router = inject(Router);

  progressService.start();

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (
        err instanceof HttpErrorResponse &&
        request.context.get(SUPPRESS_GLOBAL_ERROR_FEEDBACK)
      ) {
        return throwError(() => err);
      } else if (err instanceof HttpErrorResponse && err.status === 401 && err.headers.get('token-expired') === 'true') {
        return throwError(() => err);
      } else if (err instanceof HttpErrorResponse && err.status === 403) {
        router.navigate(['error/access-denied']);
        return throwError(() => err);
      } else if (err instanceof HttpErrorResponse && (err.status === 500 || err.status === 400)) {
        const error = (err.error && (err.error.message || err.error)) || err.statusText || 'Server error';
        alertService.error(String(error));

        if (err.status === 400 && String(error) === 'Refresh token is invalid!') {
          alertService.error(String(error) + ' Logging out...');
          authService.logout().subscribe({
            next: () => router.navigate(['/auth/login']),
            error: () => router.navigate(['/auth/login'])
          });
        }

        return throwError(() => err);
      } else if (err && (err as any).status === 0) {
        const error = 'Unable to connect to server! Please try again.';
        alertService.error(error);
        return throwError(() => new Error(error));
      } else {
        const error = (err.error != undefined ? (err.error.message ?? err.error) : err.message) || err;
        alertService.error(String(error));
        return throwError(() => err);
      }
    }),
    finalize(() => progressService.complete())
  );
}
